// private
let localConfig: any = null;

export async function loadLocalConfig() {
  if (process.env.REACT_APP_ENV === 'local') {
    try {
      //@ts-ignore
      const config = await import('../../localConfig.json')
      if (window.location.host.includes('connect.foo.redhat.com')) {
        localConfig = config.connect;
        console.log("Local config is:", localConfig);
      } else if (window.location.host.includes('developers.foo.redhat.com')) {
        localConfig = config.developers;
        console.log("Local config is:", localConfig);
      } else if (window.location.host.includes('docs.foo.redhat.com')) {
        localConfig = config.docs;
        console.log("Local config is:", localConfig);
      } else if (window.location.host.includes('kbe.foo.redhat.com')) {
        localConfig = config.kbe;
        console.log("Local config is:", localConfig);
      } else if (window.location.host.includes('cloud.foo.redhat.com')) {
        localConfig = config.cloud;
        console.log("Local config is:", localConfig);
      } else if (window.location.host.includes('offline-portal.foo.redhat.com')) {
        localConfig = config.offlinePortal;
        console.log("Local config is:", localConfig);
      } else if (window.location.host.includes('workyourway.foo.redhat.com')) {
        localConfig = config.workyourway;
        console.log("Local config is:", localConfig);
      }else {
        console.log("Host not supported. Use local.foo.redhat.com:8000 OR connect.foo.redhat.com:8000 OR kbe.foo.redhat.com:8000 OR cloud.foo.redhat.com:8000 OR offline-portal.foo.redhat.com:8000")
      }
    }
    catch (err) {
      console.log('Error loading localConfig.json. Try running task "npm run makeLocalConfig"')
    }
  }
}

export function getLocalConfig(key: string): any {
  return localConfig?.[`${key}`];
}
